import { useApi } from './useApi';

export function useService() {
  const { fetchData, postData, putData, data, error, loading } = useApi();

  const createServiceApi = async (credentials) => {
    try {
      const result = await postData('/api/services', credentials);
      return {
        success: true,
        data: result
      };
    } catch (err) {
      return { 
        success: false, 
        error: err.message 
      };
    }
  };

  const updateServiceApi = async (id, credentials) => {
    try {
      const result = await putData(`/api/services/${id}`, credentials);
      
      return {
        success: true,
        data: result
      };
    } catch (err) {
      return { 
        success: false, 
        error: err.message || 'Lỗi kết nối' 
      };
    }
  };

  const getServicesApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/services', { params });
      
      return {
        success: true,
        data: result
      };
    } catch (err) {
      return { 
        success: false, 
        error: err.message || 'Lỗi kết nối' 
      };
    }
  };

  return { createServiceApi, getServicesApi, loading, updateServiceApi };
}